export const home = {
  myReports: {
    title: "Your reports",
  },
  meta: {
    untitledJob: 'Untitled job',
    noAssetLinked: 'No asset linked',
    unassigned: 'Unassigned',
    emDash: '—',
  },
  aggregation: {
    scheduledInspectionFallback: 'Scheduled inspection',
    jobOverdueSubtitle: '{{asset}} · Due {{date}}',
    jobOverdueNoDate: '{{asset}} · Overdue',
    jobOverdueUnassigned: 'Overdue job',
    inspectionOverdueSubtitle: '{{asset}} · Was due {{date}}',
    requestOverdueSubtitle: '{{asset}} · Was due {{date}}',
    jobDueTodaySubtitle: '{{asset}} · Due today',
    inspectionDueTodaySubtitle: '{{asset}} · Due today',
    inspectionScheduledSubtitle: '{{asset}} · Scheduled {{date}}',
    jobInProgressSubtitle: '{{asset}} · In progress',
    followOnApprovalSubtitle: '{{asset}} · Follow-on approval',
    completionReviewSubtitle: '{{asset}} · Completion review',
    scheduledBadge: 'Scheduled',
    inProgressBadge: 'In progress',
    approvalBadge: 'Approval',
    requestSubtitle: '{{asset}} · Follow-up',
    followUpQueuePending: 'New',
    followUpQueueAwaitingCustomer: 'Waiting on customer',
    followUpQueueApproved: 'Approved',
    followUpQueueScheduled: 'Scheduled',
    followUpQueueConverted: 'Linked work',
    followUpQueueRejected: 'Declined',
    certificateActionsTitle: 'Certificates due',
    certificateActionsEmpty: 'No certificates due',
    certificatePendingValidation: 'Pending validation',
    certificateRejected: 'Rejected',
    certificateExpired: 'Expired',
    certificateExpiringSoon: 'Expiring soon',
  },
  greeting: {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    withName: '{{greet}}, {{name}}',
  },
  screen: {
    title: 'Home',
    loadingCommandCenter: 'Loading your home…',
  },
  /** Home command center: top metrics row */
  summaryStrip: {
    assets: 'Assets',
    openJobs: 'Open jobs',
    dueToday: 'Due today',
    requests: 'Requests',
  },
  commandQuickActions: {
    scanQr: 'Scan QR',
  },
  commandEmpty: {
    dueToday: 'Nothing due today.',
    needsAttention: 'Nothing needs attention right now.',
    requests: 'No requests yet. Shared asset requests will appear here.',
    recentActivity: 'No recent activity.',
  },
  commandSectionTitles: {
    overdue: 'Overdue',
    dueToday: 'Due today',
    requests: 'Requests',
    recentActivity: 'Recent activity',
  },
  /** Phase 2 Operations Command Centre — section labels for the new home sections. */
  commandCenter: {
    statusBar: {
      actionRequired: 'Action required',
      needsAttention: 'Needs attention',
      allSystemsNormal: 'All systems normal',
      synced: 'Synced {{label}}',
    },
    aiBriefing: {
      label: 'Operations briefing',
      readMore: 'Read briefing →',
    },
    attentionQueue: {
      title: 'Attention queue',
      empty: 'Inbox zero. Nothing demands you right now.',
      showMore: '{{count}} more →',
      snooze: 'Snooze',
      kind: {
        request: 'Requests',
        inspection: 'Inspections',
        job: 'Jobs',
        document: 'Documents',
        activity: 'Activity',
      },
    },
    counters: {
      dueInspections: 'Due inspections',
      openRequests: 'Open requests',
      openJobs: 'Open jobs',
      workQueue: 'Work queue',
    },
    recentActivity: {
      title: 'Recent activity',
      defaultEmpty: 'No activity yet today.',
      events_one: '{{count}} event',
      events_other: '{{count}} events',
    },
  },
  empty: {
    firstAssetTitle: 'Create your first asset',
    firstAssetSubtitle: 'Add an asset to start inspections and manage work.',
    noAssetsInScopeTitle: 'No assets in {{scope}}',
    noAssetsInScopeSubtitle: 'Change the scope filter above or add assets to this team.',
    noAssetsInScopeSubtitleWeb:
      'Change the scope filter or clear search — assets matching your filters will show here.',
    noAssetsInScopeShortWeb: 'Change scope or add assets to this team.',
    addAsset: 'Add asset',
  },
  planNudge: {
    asset_cap: 'One asset left on your plan ({{limit}} included). {{plan}} has no limit.',
    asset_cap_limited: 'One asset left on your plan ({{limit}} included). {{plan}} includes {{nextLimit}}.',
    same_contact: 'You have sent {{name}} {{count}} jobs this month. On {{plan}} they see and update them themselves.',
    addresses: 'Your assets are at {{count}} addresses. Sites, on {{plan}}, groups the work by place.',
    inspections: '{{count}} inspections in a week is a lot for one person. Teams, on {{plan}}, shares the load.',
    seePlans: 'See {{plan}}',
    dismiss: 'Not now',
  },
  teamSetup: {
    title: 'Set up your team',
    dismiss: 'Dismiss team set-up',
    steps: {
      invite: 'Invite a teammate',
      site: 'Add a site',
      requests: 'Let people raise work (share an asset)',
    },
  },
  firstRun: {
    /** components/home/FirstRunMomentumCard.tsx defaults — used only when a caller omits the prop. */
    progress: '{{completed}} of {{total}} done',
    gettingStartedDefault: 'Getting started',
    dismissDefault: 'Dismiss getting started',
    trySampleDefault: 'Try a sample',
    removeSampleDefault: 'Remove sample',
    title: "Get started",
    subtitle: "Tap a step. Each one shows you exactly where to tap.",
    trySample: 'Try sample',
    removeSample: 'Remove sample',
    createAsset: 'Create asset',
    startInspection: 'Start inspection',
    dismiss: 'Not now',
    whatIsThis: 'What is this?',
    whatIsThisBody: "AssetWRX keeps your assets, inspections and jobs in one place, so you always know what needs doing next.",
    busy: 'Setting up…',
    error: 'Could not set up the sample. You can still create an asset manually.',
    suggested: "Suggested",
    steps: {
      document: "Add a certificate",
      asset: "Add your first asset",
      request: "Share an asset with someone",
      inspection: "Schedule an inspection",
      job: "Create a job",
      contacts: "Invite a colleague",
      contactsNoTeams: "Add a contact",
    },
    coachmark: {
      title: "Start here",
      body: "Tap any step to start. You can do them in any order.",
      dismiss: "Got it",
    },
  },
  web: {
    commandOverline: 'Find and create',
    commandHint: 'Search the workspace, set scope, or add assets, jobs, and inspections.',
    searchPlaceholder: 'Search assets, jobs, inspections, reports...',
    overviewTitle: 'Overview',
    overviewHint: 'Shortcuts and live counts for your current scope. Tap a KPI tile to open the full list.',
    overviewSnapshotLabel: 'Snapshot',
    overviewSnapshotHintWeb: 'Assets · Inspections · Jobs — tap a tile to open that list.',
    suggestedActionsTitle: 'Suggested actions',
    suggestedActionsHint:
      'Rule-based priorities from this scope. Open a card to jump to the right list or job.',
    workQueueTitle: 'Work queue',
    workQueueHint: 'Prioritized jobs and inspections for this scope. Select a row to see details.',
    activeWorkQueueTitle: 'Active work queue',
    workQueueSectionMeta: 'Jobs, inspections, and schedules — filter or open a row for details.',
    queueEmptyNoItems: 'No actionable jobs or inspections in this scope.',
    queueEmptyNoFilter: 'No queue items match this filter.',
    automationHint:
      'Conversions, rule-based job suggestions from completed inspections, and team invites.',
    detailJobTitle: 'Job details',
    detailOverviewTitle: 'Overview',
    detailEmpty:
      'No work items in this scope yet. Use Quick create in the header to get started.',
    detailCommandSummary: 'Command summary',
    detailIdleLead:
      'Select any row in the queue for full details, primary actions, and recent activity.',
    detailStatOpenJobs: 'Open jobs',
    detailStatOverdue: 'Overdue',
    detailStatUnassigned: 'Unassigned',
    detailNextUp: 'Next up in queue',
    viewAssetDetailsA11y: 'View all asset details',
    scheduleWorkA11y: 'Schedule work',
    moreActions: 'More actions',
    moreActionsA11y: 'More actions',
    copilotSectionTitle: 'Operations assistant',
    copilotEmptyTitle: 'No prioritized signals',
    copilotEmptyBody:
      'Nothing urgent surfaced for this scope yet. Adjust filters, add work, or review Insights and Work for trends.',
    copilotDockHint: 'Rule-based priorities from your current scope. Each card links to the right list or job.',
  },
  snapshot: {
    inspectionsSublabelDrafts: 'Drafts & paused',
    inspectionsSublabelScheduled_one: 'Drafts & paused · {{count}} scheduled',
    inspectionsSublabelScheduled_other: 'Drafts & paused · {{count}} scheduled',
    jobsSublabelNotClosed: 'Not closed',
    jobsSublabelOverdue_one: 'Not closed · {{count}} overdue',
    jobsSublabelOverdue_other: 'Not closed · {{count}} overdue',
    inThisScope: 'In this scope',
    findingsSublabel: 'Completed reports w/ failed items',
    unassignedSublabel: 'Open jobs, no owner',
  },
  queueFilter: {
    all: 'All work',
    overdue: 'Overdue',
    inProgress: 'In progress',
    dueSoon: 'Due soon',
  },
  queue: {
    labels: {
      asset: 'Asset',
      due: 'Due',
      status: 'Status',
      assignee: 'Assigned to',
      scheduled: 'Scheduled',
      nextStep: 'Next step',
      started: 'Started',
      priority: 'Priority',
      created: 'Created',
      location: 'Location',
      dueDate: 'Due date',
    },
    status: {
      overdue: 'Overdue',
      due: 'Due',
      paused: 'Paused',
      inProgress: 'In progress',
      awaitingSchedule: 'Awaiting schedule',
      unassigned: 'Unassigned',
    },
    subtitle: {
      overdue: '{{asset}} • Overdue',
      activeWork: '{{asset}} • Active work',
      dueThisWeek: '{{asset}} • Due this week',
      scheduledInspection: '{{asset}} • Scheduled inspection',
      needsSchedule: '{{asset}} • Needs schedule',
      unassigned: '{{asset}} • Unassigned',
      resumeChecklist: '{{asset}} • Resume checklist',
    },
    title: {
      inspectionOverdue: 'Inspection overdue',
      inspectionDue: 'Inspection due',
      inspectionInProgress: 'Inspection in progress',
    },
    typeJob: 'Job',
    typeInspection: 'Inspection',
    primaryOpenJob: 'Open job',
    primaryResumeInspection: 'Resume inspection',
    primaryStartInspection: 'Start inspection',
    openWork: 'Open work',
    nextStepSetSchedule: 'Set date and time',
    nextStepAssign: 'Assign team or contractor',
  },
  sections: {
    quickActions: 'Quick actions',
    quickActionsCardTitle: 'Shortcuts',
    quickActionsHintSetup: 'Scan and create work.',
    quickActionsHintFull: 'Scan, create work, and jump to urgent items.',
    snapshot: 'Snapshot',
    snapshotHint: 'Assets · Inspections · Jobs — tap to open',
    myWork: 'My work',
    myWorkHint: 'Continue, assign, or finish what you own.',
    needsAttention: 'Needs attention',
    needsAttentionHint: 'Grouped by type — same items as before, easier to scan.',
    workflowSuggestions: 'Workflow suggestions',
    workflowHint: 'Inspection workflow outcomes ready for the next step.',
    viewAll: 'View all',
    attentionQueue: 'Attention',
    attentionQueueCollapsedHint: 'Tap to expand the full priority breakdown',
    attentionQueueShowLess: 'Show less',
    attentionEmpty: 'No urgent work in scope.',
    moreToolsTitle: 'More tools',
    moreToolsBody: 'Insights, full activity feed, and the workbench.',
    contractorInvitesBanner_one: 'You have an invitation to quote or take on work — tap to respond',
    contractorInvitesBanner_other: 'You have {{count}} invitations to quote or take on work — tap to respond',
    /** Collapsed below-the-fold workspace lists (schedules, in-flight jobs, activity). */
    workspaceDeeperTitle: 'More work signals',
    workspaceDeeperSummary: 'Schedules, active work, and activity.',
    commandShortcutsTitle: 'Create or open',
    commandShortcutsSummary: 'Add work or open the next queue.',
    jumpToTitle: 'Jump to',
    jumpToSummary: 'Core registers and reports.',
  },
  welcome: {
    subtitleDefault: 'Work today',
    subtitleRecipient: 'Shared reports and jobs need your response',
  },
  kpiStrip: {
    pendingReviews: 'Reviews',
    pendingReviewsSub: 'Awaiting your response',
    complianceSub: 'Documents & overdue inspections',
  },
  attentionGroups: {
    approvals: 'Approvals & reviews',
    people: 'People & responses',
    time: 'Time & risk',
  },
  tasks: {
    jobInvitations: { title: 'Job invitations', sub: 'Accept or decline' },
    yourTurn: { title: 'Your turn', sub: 'Accept or decline job' },
    reworkRequested: { title: 'Rework requested', sub: 'Reassign job' },
    workInProgress: { title: 'Work in progress', sub: 'Complete or post update' },
    scheduleProposed: { title: 'Schedule proposed', sub: 'Set date and time' },
    approvedRepairs: { title: 'Approved repairs', sub: 'Create jobs' },
    unassignedWork: { title: 'Unassigned work', sub: 'Assign team or contractor' },
    draftInspection: { title: 'Draft inspection', sub: 'Resume' },
    inspectionDue: { title: 'Inspection due', sub: 'Overdue or 60+ days' },
    criticalIssues: { title: 'Critical issues', sub: 'Health status Poor' },
    followOnProposed: { title: 'Follow-on proposed', sub: 'Approve or reject before assignment' },
    completionSubmitted: { title: 'Completion submitted', sub: 'Approve or request rework' },
    reportAwaitingReview: { title: 'Report awaiting review', sub: 'Approve or decline repairs' },
    awaitingRecipient: { title: 'Awaiting recipient', sub: 'Review' },
    awaitingRecipientResponse: { title: 'Awaiting recipient response', sub: 'Track and nudge pending reviews' },
    overdueJobs: { title: 'Overdue jobs', sub: 'Resolve stalled work' },
  },
  pinned: {
    scanQr: 'Scan QR',
    inspect: 'Inspect',
    createJob: 'Create job',
  },
  contextual: {
    reviewReport: 'Review report',
    respondToAssignment: 'Respond to assignment',
    approveFollowOn: 'Approve follow-on',
    approveCompletion: 'Approve completion',
    continueJob: 'Continue job',
    resumeInspection: 'Resume inspection',
    addAsset: 'Add asset',
  },
  webQuickCreate: {
    createInspection: 'Create inspection',
    createTemplate: 'Create checklist',
    createJob: 'Create job',
    scheduleWork: 'Schedule work',
    /** Compact command-center create strip (Home). */
    shortAsset: 'Asset',
    shortRequest: 'Request',
    shortInspection: 'Inspect',
    shortJob: 'Job',
  },
  kpi: {
    assets: 'Assets',
    inspections: 'Inspections',
    jobs: 'Jobs',
    unassigned: 'Unassigned',
    findings: 'Findings',
  },
  automation: {
    approvedRepairsTitle: 'Approved repairs',
    suggestedJobsTitle: 'Follow-up jobs from inspection',
    teamInvitesTitle: 'Team invitations',
  },
  urgency: {
    critical: 'Critical',
    medium: 'Medium',
    low: 'Low',
  },
  /** components/home/sections/PriorityDot.tsx accessibility label. */
  priorityDot: {
    a11y: 'Priority {{level}}',
    level: {
      p1: 'critical',
      p2: 'medium',
      p3: 'low',
      none: 'none',
    },
  },
  /** components/home/sections/HomeWorkLanes.tsx — the per-kind work lanes. */
  workLanes: {
    kindLabel: {
      request: 'Requests',
      inspection: 'Inspections',
      job: 'Jobs',
    },
    // Lowercase forms for the "View all N …" sentence — kept as their own keys
    // rather than lowercasing the translated label, which is unsafe once a
    // locale's label is not simple ASCII casing.
    kindLabelLower: {
      request: 'requests',
      inspection: 'inspections',
      job: 'jobs',
    },
    empty: 'Nothing needs you here.',
    viewAll: 'View all {{count}} {{kind}} →',
  },
  /** components/home/sections/HomeAssetGroups.tsx — the per-asset work groups. */
  assetGroups: {
    overdueBadge_one: '{{count}} overdue',
    overdueBadge_other: '{{count}} overdue',
    needsYouBadge: '{{count}} for you',
    openAssetMore: 'Open asset · {{count}} more →',
    openAsset: 'Open asset →',
    moreAssets_one: '{{count}} more asset with open work',
    moreAssets_other: '{{count}} more assets with open work',
  },
  /** components/home/HomeSharedAssetsCards.tsx — shared-asset invite cards. */
  sharedAssets: {
    invitesA11y_one: '{{count}} asset invitation — accept or decline',
    invitesA11y_other: '{{count}} asset invitations — accept or decline',
    invitesTitle_one: 'An asset was shared with you',
    invitesTitle_other: '{{count}} assets were shared with you',
    tapToAcceptOrDecline: 'Tap to accept or decline',
    activeA11y: '{{name}} — shared with you. Open to report an issue or see its work.',
    activeSub: 'Shared with you · Report an issue or see its work',
  },
  /** components/home/HomeSectionCard.tsx defaults. */
  sectionCard: {
    otherGroup: 'Other',
    emptyDefault: 'Nothing here yet',
  },
  /** components/home/sections/HomeCommandCentre.tsx — the Home decision hub. */
  commandCentre: {
    showMeHow: "Show me how",
    calendar: 'Calendar',
    stateLabel: {
      actionNeeded: 'Action needed',
      watch: "Keep an eye on",
      active: 'Active',
      clear: 'Clear',
    },
    eyebrow: {
      needsYou: 'Needs you',
      now: 'Now',
      decision: 'Decision',
    },
    onYourPlate: 'On your plate',
    watchlist: "Keep an eye on",
    upNext: 'Up next',
    portfolioMovement: "What changed",
    workspaceSummary: "Workspace summary",
    toMonitor: "{{count}} to check",
    seeAll: 'See all',
    seeAllA11y: 'See all {{count}}',
    assetRowA11y: '{{name}}. {{state}}. {{reason}}',
    signalLabels: {
      needsYou: 'Needs you',
      atRisk: 'At risk',
      inMotion: "Active",
      dueSoon: 'Due soon',
    },
    viewDetails: 'View details',
    moreOnAsset_one: '{{count}} more on {{name}} needs the same decision',
    moreOnAsset_other: '{{count}} more on {{name}} need the same decision',
    moreOnAssetA11y_one: "{{count}} more on {{name}} needs the same decision. Open it in Work",
    moreOnAssetA11y_other: "{{count}} more on {{name}} need the same decision. Open them in Work",
    signalRowA11y: '{{action}}: {{name}}. {{reason}}',
  },
  /** lib/homeDecisionModel.ts — reasons and next-actions on the decision signals (built outside React via i18n.t). */
  decisionModel: {
    action: {
      confirm: 'Confirm',
      reply: 'Reply',
      review: 'Review',
      resolve: 'Resolve',
      createWork: 'Create work',
      resubmit: 'Resubmit',
      inviteMore: 'Invite more',
      respond: 'Respond',
      open: 'Open',
      quote: 'Quote',
      triage: 'Decide',
      resume: 'Resume',
      start: 'Start',
      continueJob: 'Continue',
      inspect: 'Inspect',
    },
    reason: {
      overdue: 'Overdue work needs attention',
      blocked: 'Work is blocked and needs a decision',
      doneConfirmWithName: '{{name}} marked this done — confirm the fix',
      doneConfirm: 'The work is done — confirm the fix',
      visitConfirmWithName:
        '{{name}} planned a visit — confirm someone can be there, or ask for a different time',
      visitConfirm: 'A visit is planned — confirm someone can be there, or ask for a different time',
      needMoreInfo: 'The team needs more information from you',
      waitingYourReview: 'Waiting for your review',
      waitingYourReviewWithName: '{{name}} is waiting for your review',
      reviewWaiting: 'A review or approval is waiting',
      approvedNoWorkYet: 'Approved — the work has not been created yet',
      reworkSentBackWithName: 'Sent back to {{name}} for rework — waiting for them to complete it again',
      reworkSentBack: 'Sent back for rework — waiting for it to be completed again',
      reworkOwnerRedo: 'Sent back for rework — redo the work and complete it again',
      quotesDeclined: 'Everyone invited declined to quote — invite more contractors',
      waitingRequesterConfirm: 'Waiting for the requester to confirm the fix',
      acceptOrDeclineYou: 'Assigned to you — accept or decline before the work starts',
      waitingAcceptWithName: 'Waiting for {{name}} to accept or decline',
      waitingAccept: 'Waiting for the assignee to accept or decline',
      waitingTriageWithName: '{{name}} is waiting for a decision',
      waitingTriage: 'A requester is waiting for a decision',
      workspaceUnavailable: "We couldn't load your workspace. Tap to try again.",
      dueToday: 'Due today',
      invitedToQuote: 'Invited to quote — reply with a price, or decline',
      pausedWithReason: 'Paused — {{reason}}. Resume when you can',
      pausedResume: 'Paused — resume when you can',
      onThisJob: 'You are on this job — complete it when the work is done',
      assignedStartOnSite: 'Assigned to you — start when you are on site',
      scheduledApproaching: 'Scheduled work is approaching',
      pausedWithReasonOnly: 'Paused — {{reason}}',
      paused: 'Paused',
      inProgress: 'Work is in progress',
      fallback: 'Operational attention is required',
    },
    assetReason: {
      actionRequired: 'Action is required',
      criticalRisk: 'Critical asset risk',
      elevatedRisk: 'Elevated asset risk',
      operationalConcern: 'Operational concern',
      activeOrScheduled: 'Work is active or scheduled',
      noException: "Nothing needs attention",
    },
    assetWatchSignal: {
      criticalMonitor: 'Critical asset risk requires monitoring',
      elevatedMonitor: 'Elevated asset risk requires monitoring',
      conditionNeedsAction: 'Condition needs action',
    },
    brief: {
      itemsNeed_one: '{{count}} item needs attention.',
      itemsNeed_other: '{{count}} items need attention.',
      conditionsWatchClause_one: " {{count}} more to keep an eye on.",
      conditionsWatchClause_other: " {{count}} more to keep an eye on.",
      nothingNeedsYou: 'Nothing needs you right now.',
      watchlist_one: "Nothing needs you right now. {{count}} thing to keep an eye on.{{motion}}",
      watchlist_other: "Nothing needs you right now. {{count}} things to keep an eye on.{{motion}}",
      inMotionOnly_one: "Nothing needs you right now. {{count}} item is planned or underway.",
      inMotionOnly_other: "Nothing needs you right now. {{count}} items are planned or underway.",
      invitationsOnly_one: "{{count}} invitation to quote or take on work is waiting for your answer.",
      invitationsOnly_other: "{{count}} invitations to quote or take on work are waiting for your answer.",
      inMotionClause_one: " {{count}} item is planned or underway.",
      inMotionClause_other: " {{count}} items are planned or underway.",
    },
  },
  copilot: {
    overdue: {
      title: 'Overdue work',
      body_one: '{{count}} open job with a due date in the past. Prioritize scheduling or closing it.',
      body_other: '{{count}} open jobs with a due date in the past. Prioritize scheduling or closing them.',
      action: 'Open jobs',
    },
    failedFindings: {
      title: 'Inspection findings',
      body_one:
        '{{count}} completed inspection in this scope include failed items. Convert critical findings into jobs when ready.',
      body_other:
        '{{count}} completed inspections in this scope include failed items. Convert critical findings into jobs when ready.',
      action: 'Inspections',
    },
    throughput: {
      title: 'Completion pace',
      bodyUp:
        'Verified job completions accelerated in the second half of the last {{days}} days compared to the first half.',
      bodyDown:
        'Verified job completions slowed in the second half of the last {{days}} days. Review blockers in the work queue.',
      action: 'Work queue',
    },
    unassigned: {
      title: 'Assignment coverage',
      body_one: '{{count}} open job has no assignee. Assign owners to improve accountability.',
      body_other: '{{count}} open jobs have no assignee. Assign owners to improve accountability.',
      action: 'Jobs',
    },
    assetHealth: {
      title: 'Assets under stress',
      body_one:
        '{{count}} asset in this scope scores in the poor health band (open work, findings, or staleness).',
      body_other:
        '{{count}} assets in this scope score in the poor health band (open work, findings, or staleness).',
      action: 'Assets',
    },
    allClear: {
      title: 'Operations snapshot',
      body: 'No urgent copilot signals in this scope for the last {{days}} days. Review charts for trends and keep assignments current.',
    },
  },
  copilotCards: {
    sync: {
      primary: "See unsent changes",
      body_other: "{{count}} changes are saved on this device, waiting to be sent.",
      body_one: "1 change is saved on this device, waiting to be sent.",
      title: "Changes not sent yet",
    },
    requests: {
      primary: "Review requests",
      body: "Open the requests to see how urgent each one is and turn them into work.",
      title_other: "{{count}} urgent requests to review",
      title_one: "1 urgent request to review",
    },
    brief: {
      draft: "Draft today's action brief for {{overdue}} overdue items and {{today}} due today. Put what needs attention first and keep it short.",
      primary: "Draft a plan",
      body: "{{overdue}} overdue and {{today}} due today. The assistant can put them in order.",
      title: "Plan today's work",
    },
  },
  syncBanner: {
    pending_one: "Sync pending: {{count}} offline write waiting to retry.",
    pending_other: "Sync pending: {{count}} offline writes waiting to retry.",
  },
  healthEntries: {
    ok: "OK",
    syncLabel: "Sync",
    syncPending_one: "{{count}} pending",
    syncPending_other: "{{count}} pending",
    syncUpToDate: "Up to date",
    failedSyncsLabel: "Failed syncs",
    failedSyncsCount_one: "{{count}} failed",
    failedSyncsCount_other: "{{count}} failed",
    iotLabel: "IoT",
    iotCount_one: "{{count}} warning",
    iotCount_other: "{{count}} warnings",
    iotTitle: "IoT warnings",
    iotEmpty: "No IoT warnings.",
  },
} as const;
